// extracted by mini-css-extract-plugin
export var active = "_cb-7";
export var blink = "_cb-8";
export var dropDownSelector = "_cb-4";
export var dropDownWrapper = "_cb-3";
export var fakeCursor = "_cb-6";
export var fontSizeButton = "_cb-9";
export var formQuillEditor = "_cb-0";
export var pressed = "_cb-a";
export var qlBlank = "_cb-1";
export var textFormattingToolbar = "_cb-2";
export var textToolbarOption = "_cb-5";